import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconDesktopStyle0 = gravityIconIndividualCss;

const GravityIconDesktop = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: 'cf54dd6cb8838b923f7d0b11b8f2678389aa3fd8', color: this.color, size: this.size }, h("svg", { key: '0181080ccb68a4497b9470e2f1dd403472a040f4', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '4b331c8afbcee2e98cc44773c635433453ced3a9', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M3.5 4a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5v-10a.5.5 0 0 0-.5-.5h-15Zm14 1.5v8h-13v-8h13Zm-11 12a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V18a.5.5 0 0 0-.5-.5h-9Z", fill: "currentColor" }))));
    }
};
GravityIconDesktop.style = GravityIconDesktopStyle0;

export { GravityIconDesktop as gravity_icon_desktop };

//# sourceMappingURL=gravity-icon-desktop.entry.js.map